<template>
  <v-row justify="center" style="background-color: ghostwhite; height: 78vh;">
    <Product v-for="product in products" :item="product" :key="product.name" />
  </v-row>
</template>


<script>
import Product from './Product.vue'

export default {

  name: 'Products',

  components: {
    Product
  },

  data: () => ({
    products: [
      {
        name: 'CocaCola Mesh Zero',
        image: 'cola.png',
        uom: 'Unit',
        rate: '$14.99',
        qty: 5
      },
      {
        name: 'Milk 2 Liters',
        image: 'cola.png',
        uom: 'Liter',
        rate: '$9.99',
        qty: 100
      },
      {
        name: 'Rice',
        image: 'rice.png',
        uom: 'Kg',
        rate: '$24.99',
        qty: 5
      }
    ]
  })

}
</script>

<style>
</style>